import { Injectable } from "@angular/core";
import { IUserConfig } from "src/app/Models/Interface/Auth/user-config";
import { UserConfigService } from "src/app/Services/AuthService/user-config.service";
import { EUserPermission } from "../../Models/Enum/user-permission";

@Injectable({
  providedIn: "root",
})
export class UserDetailsService {
  user = {} as IUserConfig;

  constructor(private userConfigService: UserConfigService) {
    this.userConfigService.getUserConfig().subscribe((res) => {
      this.user = res;
    });
  }

  checkPermissions(permission: EUserPermission): boolean {
    return this.user.userPermissionsLists.some(
      (c) => c.permissionCode === permission
    );
  }
}
